import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const removeAll: SxStyleFunc<number> = (length) => ({
  justifyContent: 'center',
  display: length < 1 ? 'none' : 'flex',
  gap: 0.5,
  alignItems: 'center',
  borderWidth: '1px',
  width: (p) => p.spacing(3),
  height: (p) => p.spacing(3),
  cursor: 'pointer',
  mx: 0.5,
  transition: 'all 0.2s ease-in',
});

export const scrollBtn: SxStyleFunc<boolean | undefined> = (
  canScrollRight
) => ({
  display: canScrollRight ? 'flex' : 'none',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.common.white,
  cursor: 'pointer',
  mx: 0.5,
});

export const scrollButtonWrapper: SxStyleFunc<{
  hover: boolean;
  length: number;
}> = ({ hover, length }) => ({
  paddingRight:
    hover && length >= 2 ? (p) => p.spacing(2.5) : (p) => p.spacing(0.5),
});
